export default __webpack_public_path__ + "static/media/loja-icon.f63b0a9c.svg";